import { useState, useEffect } from "react";
import { TeamMemberDto, UserSort } from "../lib-api/models";
import { LoadingState } from "./loading";
import useApi from "./api";
import { useQueryDelay } from "./queryDelay";
import useAuth from "./auth";

export function useUser(page: number, amount: number, sortMode: UserSort, searchQuery: string) {
  const [state, setState] = useState(LoadingState.None);
  const [results, setResults] = useState<
  TeamMemberDto[]
  >([]);
  const [totalUsers, setTotalUsers] = useState<number|undefined>(undefined);
  const { delay } = useQueryDelay(searchQuery);
  const { userApi } = useApi();
  const {user} = useAuth();

  const load = async () => {
    setState(LoadingState.Loading);

    try {
      const searchResult = await userApi.apiUserAllPost({
        searchUserRequest: {
          page: page,
          pageSize: amount,
          sortMode: sortMode,
          searchQuery: searchQuery
        }
      });
      setResults(searchResult.all);
      setTotalUsers(searchResult.totalCount);
      setState(LoadingState.Success);
    } catch (e) {
      setState(LoadingState.BadRequest);
    }
  };

  useEffect(() => {
    load();
  }, [page, amount, sortMode, delay, user?.teamId]);

  return {
    results: results,
    totalUsers: totalUsers,
    searchState: state,
    reload: load
  };
}
